import { render, staticRenderFns } from "./AlibiList.vue?vue&type=template&id=10ed884d"
import script from "./AlibiList.vue?vue&type=script&lang=js"
export * from "./AlibiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports